// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__l-fxH","load4":"Spinner_load4__YiWMf"};